export const getQuery = state => state.api.query;
export const getRefresh = state => state.api.refresh;

export default {
	getQuery,
	getRefresh,
};
